<!--
  Forbrukerrådet - Kommunetesten
  @link https://gitlab01.copyleft.no/FBR/kommunetesten-new
  @author Anders Evenrud <anders.evenrud@copyleft.no>
-->

<template>
  <div class="positions">
    <ul>
      <li v-for="(row, index) in items" :key="index">
        <div>{{ row.label }}</div>
        <div class="points">
          <div>{{ scoreLabel(row) }}</div>
          <div>av</div>
          <div>{{ row.max || 0 }}</div>
        </div>
      </li>
    </ul>
  </div>
</template>

<style lang="scss" scoped>
@import "../assets/variables";
@import "../assets/mixins";

.positions {
  border: $positions-border;

  ul {
    margin: 0;
    padding: 0;
    list-style-type: none;

    li {
      margin: 0;
      padding: 1em;
      display: flex;

      &:not(:last-child) {
        border-bottom: $positions-border;
      }

      & > div {
        &:first-child {
          flex: 1 1;
        }
      }
    }
  }

  .points {
    display: flex;
    white-space: nowrap;

    & > div {
      min-width: 2em;

      &:nth-child(1) {
        font-weight: bold;
        text-align: right;
        width: 3em;
      }

      &:nth-child(2) {
        text-align: center;
      }

      &:nth-child(3) {
        text-align: left;
        width: 3em;
      }
    }
  }
}
</style>

<script>
export default {
  props: {
    items: Array
  },

  methods: {
    scoreLabel (row) {
      return row.score === -1
        ? 'Ikke målt'
        : row.score || 0
    }
  }
}
</script>
